import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "",
  target: "_blank",
  class: "text-muted small"
}, " Cancel Subscription ", -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($options.is_cancellation_applicable)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "d-flex",
          style: {"position":"absolute","right":"1rem","top":"1rem","bottom":"1rem"},
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($options.cancel_subscription()), ["prevent"]))
        }, _hoisted_3)
      ]))
    : _createCommentVNode("v-if", true)
}